import { Reports } from '@core/models/reports/reports.models';
import { useQuery } from '@tanstack/react-query';
import { getReportsFromIndexedDB } from '@components/Header/ReportsDrawer/ReportsDrawer.utils';

export function useStoredReports(workspaceId?: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ['storedReports', workspaceId],
    queryFn: async (): Promise<Reports.ReportQueryData[]> => {
      if (!workspaceId) return [];
      return await getReportsFromIndexedDB(workspaceId);
    },
    enabled: Boolean(workspaceId) && enabled,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
